import { render } from "./Loader.vue?vue&type=template&id=1fce1b04&bindings={\"idVal\":\"props\",\"classVal\":\"props\"}"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script